import { MYSOFIE_SITE_URL } from '../../../../utils/consts'
import Svg from '../../../Svg'
import svgEmail from './svgs/desktop/email.svg'
import { default as svgDesktopLogo, default as svgMobileLogo } from './svgs/desktop/mysofie.svg'
import svgProfile from './svgs/desktop/profil.svg'
import svgBack from './svgs/mobile/back.svg'

const HomeNav = (props: { onProfileClick: () => void; onLogoClick: () => void }) => {
  return (
    <nav className="w-full">
      {/* Mobile */}
      <div className="md:hidden lg:hidden flex justify-between px-5 py-6">
        <div className="flex justify-start">
          <Svg alt="Retour" onClick={props.onLogoClick} src={svgBack} width={30} height={30} />
        </div>
        <Svg alt="Icone mySofie" src={svgMobileLogo} width={80} height={50} onClick={props.onLogoClick} />
        <div className="w-4"></div>
      </div>

      {/* Desktop & Tablet */}
      <div className="hidden lg:flex md:flex lg:px-4 md:px-0 py-6 items-center">
        <div className="flex justify-start">
          <Svg alt="Retour" onClick={props.onLogoClick} src={svgBack} width={30} height={30} />
        </div>
        <div className="flex-1 flex justify-end space-x-12 font-bold text-xs whitespace-nowrap">
          <Svg alt="Icone mySofie" src={svgDesktopLogo} width={88} height={55} onClick={props.onLogoClick} />
        </div>

        <div className="flex-1 flex justify-end lg:space-x-12 md:space-x-10 text-m whitespace-nowrap">
          <button
            id="offerButton"
            className=" rounded-full h-[40px] w-[200] bg-yellow px-4"
            title="Découvrir nos offres"
            onClick={() => {
              window.location.assign(MYSOFIE_SITE_URL + '/nos-produits/')
            }}
          >
            Découvrir nos offres
          </button>
          <Svg
            alt="Nous contacter"
            src={svgEmail}
            width={20}
            height={15}
            onClick={() => {
              window.location.assign(MYSOFIE_SITE_URL + '/contact/')
            }}
          />
          <Svg alt="Me connecter" src={svgProfile} width={20} height={20} onClick={props.onProfileClick} />
        </div>
      </div>
    </nav>
  )
}

export default HomeNav
